export default {
  props: {
    dark: Boolean,
    light: Boolean
  }
}



// WEBPACK FOOTER //
// ./src/mixins/themeable.js